import { auth } from '@breezeway/brzw-react-core';
import { combineReducers } from 'redux';
import constants from './constants';

export const getInitialState = (customState = {}) => ({
  [constants.NAME]: {
    ...auth.reducers.getInitialState(),
    ...customState,
  },
});

export default combineReducers({
  authenticated: auth.reducers.authenticated,
  user: auth.reducers.user,
  authError: auth.reducers.authError,
  userRegister: auth.reducers.userRegister,
  forgotPassword: auth.reducers.forgotPassword,
  passwordReset: auth.reducers.passwordReset,
  passwordTokenValidation: auth.reducers.passwordTokenValidation,
  loading: auth.reducers.loading,
  loadingLoader: auth.reducers.loadingLoader,
  userRegisterLoading: auth.reducers.userRegisterLoading,
  savedViews: auth.reducers.savedViews,
});
